// extracted by mini-css-extract-plugin
module.exports = {"item":"CategoryForm_item__lttcB"};